// Main constant
export const SKILL_PROPERTY_NAME_ALIAS = {
  POSITION: 'POSITION',
  COMPETENCY: 'COMPETENCY',
  LANGUAGE: 'LANGUAGE',
  OFFICE: 'OFFICE',
  TECHNOLOGY: 'TECHNOLOGY',
} as const;

export const SKILL_FIELD_TYPE_ALIAS = {
  AVAILABLE_POSITIONS: 'AVAILABLE_POSITIONS',
  AVAILABLE_COMPETENCY_LEVELS: 'AVAILABLE_COMPETENCY_LEVELS',
  AVAILABLE_LANGUAGES: 'AVAILABLE_LANGUAGES',
  AVAILABLE_OFFICES: 'AVAILABLE_OFFICES',
  AVAILABLE_TECHNOLOGIES: 'AVAILABLE_TECHNOLOGIES',
} as const;

export const SKILL_STATUS = {
  CERTIFIED: 'CERTIFIED',
  TRAINING: 'TRAINING',
  UNCERTIFIED: 'UNCERTIFIED',
} as const;
//

export const SKILL_STATUS_BY_ALIAS = {
  [SKILL_STATUS.CERTIFIED]: 'Certified',
  [SKILL_STATUS.UNCERTIFIED]: 'Uncertified',
  [SKILL_STATUS.TRAINING]: 'Training',
} as const;

export const ADDITIONAL_POSITIONS = {
  GENERAL: 'GENERAL',
  SCREENING_INTERVIEW: 'SCREENING_INTERVIEW',
} as const;

export const VIEW_SKILLS_PROPERTIES_VALUES = {
  [ADDITIONAL_POSITIONS.GENERAL]: 'General Interview',
  [ADDITIONAL_POSITIONS.SCREENING_INTERVIEW]: 'Screening Interview',
} as const;
